module.exports = __webpack_public_path__ + "img/no_img.37774e08.png";